import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  AllProject,
  BrokendownProjectResponse,
  ProjectResponseModel,
  ServerResponse,
} from '@models';
import { ModalSuccessService } from 'src/app/shared/modules/modal-success/modal-success.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectsService {
  private project = environment.PROJECTS;

  public projectId: string;
  public typeProjectId: string;

  public response: Subject<boolean> = new Subject<boolean>();
  public statusAssingCompany: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly http: HttpClient,
    private readonly modalSuccess: ModalSuccessService
  ) {}

  /**
   * Get all project
   *
   */
  public getAllProjects(): Observable<AllProject[]> {
    const options = {
      withCredentials: true,
    };
    return this.http
      .get<ProjectResponseModel>(this.project.PROJECTS, options)
      .pipe(map((e) => e.response));
  }

  public getBrokendownProject(
    companyId?: string
  ): Observable<BrokendownProjectResponse> {
    const filter = companyId ? `?company=${companyId}` : '';
    const path = `${this.project.BROKENDOWN}${filter}`;
    return this.http.get<BrokendownProjectResponse>(path);
  }

  public continue(): void {
    this.response.next(true);
  }

  public close(): void {
    this.response.next(false);
  }

  public patchAddCompany(data: any): Observable<{}> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');
    const options = {
      withCredentials: true,
    };
    const path = this.project.ADD_COMPANY.replace(
      '{projectId}',
      this.projectId
    ).replace('{typeProjectId}', this.typeProjectId);
    return this.http.patch(path, data, options);
  }

  public getSummary(params: string): Observable<ServerResponse> {
    return this.http.get<ServerResponse>(`${this.project.SUMMARY}${params}`);
  }
}
